module.exports = __webpack_public_path__ + "img/logo.fca2901c.png";